import { ICheckUsersAction, UsersActionTypes } from "./usersTypes";

export const checkUsers = (): ICheckUsersAction => {
  return {
    type: UsersActionTypes.CHECK_USERS,
  };
};
